import {
  IUserBookingStatus,
  EType as EUserBookingStatusType,
} from '../../repositories/newbuilding-flat-tour-booking/entities/Models/UserBookingStatus';
import { IOrderStatus, EBookingStatusType } from '../../types/newbuildingHeader';

export function transformUserBookingStatus(status: IUserBookingStatus): IOrderStatus {
  const type =
    status.type === EUserBookingStatusType.SignedUp ? EBookingStatusType.SignedUp : EBookingStatusType.NoActive;

  const description = status.description;

  return {
    type,
    description,
  };
}
